/**
 * Module « Tableau de bord » (bible §17) — première entrée du groupe Pilotage,
 * donc page d'accueil de tous les rôles (App.tsx redirige vers la première
 * route montée). Aucun rôle requis : chacun y voit ce que son rôle autorise,
 * le filtrage est fait par le serveur.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "pilotage",
  label: "Tableau de bord",
  icon: "i-grid",
  navGroup: "pilotage",
  navOrder: 10,
  rolesRequis: [],
  routes: [{ path: "/pilotage", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
